// Module
var code = "<section class=\"ib-tooltip__box--left\">\n  <h5 class=\"ib-tooltip__title\">{{ 'UPGRADING_REMEMBER' | translate }}:</h5>\n  <p class=\"ib-tooltip__text\">\n    {{ 'UPGRADING_FREE_INFO' | translate : { rango: bidsTooltipCtrl.range } }}\n  </p>\n</section>";
// Exports
module.exports = code;